import { Injectable } from "@angular/core";
import { TimeagoClock } from "ngx-timeago";
import { Observable, interval } from "rxjs";

@Injectable()
export class MyClock extends TimeagoClock {
    tick(then: number): Observable<number> {
        return interval(60000);
    }
}
